/*
  Bankstown Sound -- In-Store Exclusive guard for THIRD-PARTY pages.

  The wishlist (Wishlist by Square, /apps/api/list) and compare (Comparable,
  /pages/compare) pages render their OWN product cards, so our Liquid never
  runs there. Product/collection metafields are NOT readable by client-side JS,
  but VENDOR and TAGS are (via /products/<handle>.js). So on these two pages we:

    1. Hide the app's buy controls up-front (no flash).
    2. For each card, read its product handle, fetch /products/<handle>.js, and
       decide exclusivity from window.BTS_INSTORE.vendors / .tag.
    3. Exclusive -> inject a black "View Product" link in place of the buy
       button (matching the page's own button box). Normal -> reveal controls.

  Robust against async rendering: a card is only finalised once its handle and
  buy controls exist; otherwise it is retried on the next mutation. A safety
  timer reveals anything that never classified.
*/
(function () {
  var cfg = window.BTS_INSTORE || {};
  var vendors = (cfg.vendors || []).map(function (v) { return String(v || '').trim().toLowerCase(); }).filter(Boolean);
  var tag = String(cfg.tag || '').trim().toLowerCase();
  if (!vendors.length && !tag) { return; }

  var path = location.pathname;
  var scopes = [];
  if (/\/apps\/api\/list/.test(path)) {
    // wishlist: insert the link before the ATC button; hide ATC + qty
    scopes.push({ card: '.wls-card-content', mode: 'before', anchor: '.wls-atc-btn', hide: ['.wls-atc-btn', '.wls-qty-row'] });
  }
  if (/\/pages\/compare/.test(path)) {
    // compare: convert the existing button in place (keeps its exact box)
    scopes.push({ card: '.product-summary', mode: 'convert', host: '.add-to-cart-wrap' });
  }
  if (!scopes.length) { return; }

  // ---- hide-first + link styles -------------------------------------------
  var css = '';
  // wishlist hide-first
  css += '.wls-card-content .wls-atc-btn:not(.bts-instore-view-link),.wls-card-content .wls-qty-row{visibility:hidden;}';
  css += '.wls-card-content.bts-instore-ok .wls-atc-btn,.wls-card-content.bts-instore-ok .wls-qty-row{visibility:visible;}';
  // compare hide-first (never hide our own injected link)
  css += '.product-summary .add-to-cart-wrap > *:not(.bts-instore-view-link){visibility:hidden;}';
  css += '.product-summary.bts-instore-ok .add-to-cart-wrap > *{visibility:visible;}';

  // BASE pill -- wishlist + any NON-compare surface. Black, full width.
  css += 'body:not(.comparison-page) .bts-instore-view-link{display:flex!important;align-items:center;justify-content:center;gap:0!important;width:100%!important;box-sizing:border-box;min-height:48px;margin:0!important;padding:12px 24px!important;border:0!important;border-radius:100px!important;background:#1a1a1a!important;background-image:none!important;color:#fff!important;font-family:Gotham,"Proxima Nova",sans-serif!important;font-weight:500!important;font-size:14px!important;letter-spacing:-0.5px!important;line-height:1.2!important;text-align:center;text-decoration:none!important;white-space:nowrap!important;box-shadow:none!important;text-transform:none!important;cursor:pointer;}';
  css += 'body:not(.comparison-page) .bts-instore-view-link:hover,body:not(.comparison-page) .bts-instore-view-link:focus{background:#000!important;color:#fff!important;text-decoration:none!important;}';

  // COMPARE page -- we KEEP the app's own button element (converted to an <a>
  // that retains all its layout classes), so its box is already pixel-identical
  // to the siblings. We ONLY recolor it black and drop the cart icon.
  css += 'body.comparison-page .add-to-cart-wrap > a.bts-instore-view-link{background:#1a1a1a!important;background-image:none!important;color:#fff!important;text-decoration:none!important;box-shadow:none!important;opacity:1!important;cursor:pointer;}';
  css += 'body.comparison-page .add-to-cart-wrap > a.bts-instore-view-link:hover{background:#000!important;color:#fff!important;}';

  // kill the inherited cart-icon pseudo-element (compare) and stray pseudos
  css += '.bts-instore-view-link::before,.bts-instore-view-link::after,body.comparison-page .add-to-cart-wrap > a.bts-instore-view-link::before,body.comparison-page .add-to-cart-wrap > a.bts-instore-view-link::after{content:none!important;display:none!important;background:none!important;}';

  var st = document.createElement('style');
  st.setAttribute('data-bts-instore', '');
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  // ---- helpers -------------------------------------------------------------
  var cache = {};
  function getProduct(handle) {
    if (cache[handle]) { return cache[handle]; }
    cache[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }
  function isExclusive(p) {
    if (!p) { return false; }
    if (vendors.indexOf(String(p.vendor || '').trim().toLowerCase()) !== -1) { return true; }
    if (tag && (p.tags || []).some(function (t) { return String(t).trim().toLowerCase() === tag; })) { return true; }
    return false;
  }
  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) { return null; }
    var m = (a.getAttribute('href') || '').match(/\/products\/([^?\/#]+)/);
    return m ? m[1] : null;
  }
  function makeLink(handle) {
    var a = document.createElement('a');
    a.className = 'bts-instore-view-link';
    a.href = '/products/' + handle;
    a.textContent = 'View Product';
    return a;
  }

  function finishExclusive(s, card, handle) {
    if (card.querySelector('.bts-instore-view-link')) { return true; }
    if (s.mode === 'convert') {
      // Reuse the app's own button box: replace the buy <a>/<button> with an
      // <a> that keeps all its layout classes (minus `add-to-cart`, so the
      // app's click handler no longer matches), points at the product, and is
      // recoloured black. Pixel-identical width/height to the siblings.
      var host = card.querySelector(s.host);
      if (!host) { return false; }
      var btn = host.querySelector('a, button');
      if (!btn) { return false; }
      var link = document.createElement('a');
      var keepClasses = (btn.getAttribute('class') || '')
        .replace(/\badd-to-cart\b/g, '')
        .replace(/\bwls-[\w-]+\b/g, '')
        .replace(/\s+/g, ' ').trim();
      link.className = (keepClasses + ' bts-instore-view-link').trim();
      link.href = '/products/' + handle;
      link.textContent = 'View Product';
      btn.parentNode.replaceChild(link, btn);
    } else { // before
      var anchor = card.querySelector(s.anchor);
      if (!anchor || !anchor.parentNode) { return false; }
      anchor.parentNode.insertBefore(makeLink(handle), anchor);
      (s.hide || []).forEach(function (hs) {
        [].forEach.call(card.querySelectorAll(hs), function (e) { e.style.display = 'none'; });
      });
    }
    return true;
  }

  function process() {
    scopes.forEach(function (s) {
      [].forEach.call(document.querySelectorAll(s.card), function (card) {
        if (card.__btsState === 'done') { return; }
        var handle = handleOf(card);
        if (!handle) { return; }                       // not ready -> retry later
        // the buy control must exist before we commit
        var ready = s.host ? card.querySelector(s.host) : card.querySelector(s.anchor);
        if (!ready) { return; }                        // not ready -> retry later
        if (card.__btsState === 'pending') { return; } // fetch in flight
        card.__btsState = 'pending';
        getProduct(handle).then(function (p) {
          if (isExclusive(p)) {
            var ok = finishExclusive(s, card, handle);
            if (ok === false) { card.__btsState = null; return; } // retry
          } else {
            card.classList.add('bts-instore-ok');
          }
          card.__btsState = 'done';
        });
      });
    });
  }

  function safety() {
    scopes.forEach(function (s) {
      [].forEach.call(document.querySelectorAll(s.card), function (card) {
        if (card.__btsState !== 'done' && !card.querySelector('.bts-instore-view-link')) {
          card.classList.add('bts-instore-ok');
        }
      });
    });
  }

  var pending = false;
  function schedule() {
    if (pending) { return; }
    pending = true;
    setTimeout(function () { pending = false; process(); }, 120);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', process); }
  else { process(); }
  var mo = new MutationObserver(schedule);
  mo.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(safety, 7000);
})();
